module.exports = __webpack_public_path__ + "static/media/tictactoepic.2333e261.png";